import { createFontStyles } from './utils';

export * from './constants';
export * from './fontsStyles';
export * from './utils';

export const DEFAULT_FONT_STYLES = createFontStyles();
